import { getApplicationById } from "./components/enrollmentForm/api/getApplicationById";
import { getUsersApplications } from "./components/enrollmentForm/api/getUsersApplications";
import { fetchGroupData } from "./components/enrollmentForm/utils";

export const programOptions = [
  { value: [3, 4, 5, 6, 7, 8, 9, 10], label: "OR/eOR" },
  { value: [13], label: "TP1" },
  { value: [14], label: "TP2" },
  { value: [11, 12], label: "TT" },
];

export const applicationProgramOptions = [
  { value: [3, 4, 5, 6], label: "OR" },
  { value: [7, 8, 9, 10], label: "eOR" },
  { value: [13], label: "TP1" },
  { value: [14], label: "TP2" },
  { value: [11, 12], label: "TT" },
];

export const fetchApplication = async (
  programApplicationId,
  authToken,
  setApplication,
  setVisibleForm,
  formMethodsOne,
  formMethodsTwo,
  formMethodsThree,
  formMethodsFour,
  formMethodsFive
) => {
  const response = await getApplicationById(programApplicationId, authToken);
  setApplication(response);
  const visible = [response?.course];
  setVisibleForm(visible);
  const parsedApplication = JSON.parse(response?.application);
  if (response?.course === "OR") {
    Object.entries(parsedApplication).forEach(([key, value]) => {
      formMethodsOne.setValue(key, value);
    });
  } else if (response?.course === "eOR") {
    Object.entries(parsedApplication).forEach(([key, value]) => {
      formMethodsTwo.setValue(key, value);
    });
  } else if (response?.course === "TP1") {
    Object.entries(parsedApplication).forEach(([key, value]) => {
      formMethodsThree.setValue(key, value);
    });
  } else if (response?.course === "TP2") {
    Object.entries(parsedApplication).forEach(([key, value]) => {
      formMethodsFour.setValue(key, value);
    });
  } else {
    Object.entries(parsedApplication).forEach(([key, value]) => {
      formMethodsFive.setValue(key, value);
    });
  }
};

export const programIdToLabel = {
  1: "OR",
  2: "eOR",
  4: "TP1",
  5: "TP1",
  6: "TP1",
  13: "TP2",
  14: "TT",
};

const applicationProgramIdToLabel = {
  3: "OR",
  7: "eOR",
  13: "TP1",
  14: "TP2",
  11: "TT",
};

export const fetchUserApplications = async (
  setVisibleForm,
  data,
  authToken,
  applicationsCreated,
  formMethodsOne,
  formMethodsTwo,
  formMethodsThree,
  formMethodsFour,
  formMethodsFive,
  setApplicationsCreated,
  setIsAccepted,
  setCommentModal
) => {
  try {
    const groups = await fetchGroupData(data, authToken);
    const response = await getUsersApplications(data, authToken);
    const {
      attendanceSummary,
      therapySupervisionHours,
      iprHours,
      gprHours,
      individualSupervisionHours,
      groupSupervisionHours,
      workWithClientsHours,
      zavrsniRadovi,
      programApplications,
    } = response;
    const setFormValues = (form, values) => {
      Object.entries(values).forEach(([key, val]) => {
        form.setValue(key, val);
      });
    };
    setTimeout(() => {
      setFormValues(formMethodsThree, {
        questionTwoTP1: iprHours,
        evidentionOR1Lessons:
          attendanceSummary["OR1 - Osobni razvoj 1.godina"]
            ?.interactiveLessonAttendance,
        evidentionOR1Workshops:
          attendanceSummary["OR1 - Osobni razvoj 1.godina"]?.moduleAttendance,
        evidentionOR2Lessons:
          attendanceSummary["OR2 - Osobni razvoj 2.godina"]
            ?.interactiveLessonAttendance,
        evidentionOR2Workshops:
          attendanceSummary["OR2 - Osobni razvoj 2.godina"]?.moduleAttendance,
        evidentionEOR1Lessons:
          attendanceSummary["eOR1 - Osobni razvoj 1.godina"]
            ?.interactiveLessonAttendance,
        evidentionEOR1Workshops:
          attendanceSummary["eOR1 - Osobni razvoj 1.godina"]?.moduleAttendance,
        evidentionEOR1LiveModule:
          attendanceSummary["eOR1 - Osobni razvoj 1.godina"]
            ?.onlineORLiveModuleAttendance,
        evidentionEOR2Lessons:
          attendanceSummary["eOR2 - Osobni razvoj 2.godina"]
            ?.interactiveLessonAttendance,
        evidentionEOR2Workshops:
          attendanceSummary["eOR2 - Osobni razvoj 2.godina"]?.moduleAttendance,
        evidentionEOR2LiveModule:
          attendanceSummary["eOR2 - Osobni razvoj 2.godina"]
            ?.onlineORLiveModuleAttendance,
      });
    }, 100);
    setTimeout(() => {
      setFormValues(formMethodsFour, {
        questionTwoTP2: iprHours,
        evidentionTRIJADA: therapySupervisionHours?.trijada,
        evidentionAGS: therapySupervisionHours?.ags,
        evidentionEPER: therapySupervisionHours?.eper,
        TP2EvidentionOR1Lessons:
          attendanceSummary["OR1 - Osobni razvoj 1.godina"]
            ?.interactiveLessonAttendance,
        TP2EvidentionOR1Workshops:
          attendanceSummary["OR1 - Osobni razvoj 1.godina"]?.moduleAttendance,
        TP2EvidentionOR2Lessons:
          attendanceSummary["OR2 - Osobni razvoj 2.godina"]
            ?.interactiveLessonAttendance,
        TP2EvidentionOR2Workshops:
          attendanceSummary["OR2 - Osobni razvoj 2.godina"]?.moduleAttendance,
        TP2EvidentionOR3Lessons:
          attendanceSummary["OR3 - Osobni razvoj 3.godina"]
            ?.interactiveLessonAttendance,
        TP2EvidentionOR3Workshops:
          attendanceSummary["OR3 - Osobni razvoj 3.godina"]?.moduleAttendance,
        TP2EvidentionEOR1Lessons:
          attendanceSummary["eOR1 - Osobni razvoj 1.godina"]
            ?.interactiveLessonAttendance,
        TP2EvidentionEOR1Workshops:
          attendanceSummary["eOR1 - Osobni razvoj 1.godina"]?.moduleAttendance,
        TP2EvidentionEOR1LiveModule:
          attendanceSummary["eOR1 - Osobni razvoj 1.godina"]
            ?.onlineORLiveModuleAttendance,
        TP2EvidentionEOR2Lessons:
          attendanceSummary["eOR2 - Osobni razvoj 2.godina"]
            ?.interactiveLessonAttendance,
        TP2EvidentionEOR2Workshops:
          attendanceSummary["eOR2 - Osobni razvoj 2.godina"]?.moduleAttendance,
        TP2EvidentionEOR2LiveModule:
          attendanceSummary["eOR2 - Osobni razvoj 2.godina"]
            ?.onlineORLiveModuleAttendance,
        TP2EvidentionEOR3Lessons:
          attendanceSummary["eOR3 - Osobni razvoj 3.godina"]
            ?.interactiveLessonAttendance,
        TP2EvidentionEOR3Workshops:
          attendanceSummary["eOR3 - Osobni razvoj 3.godina"]?.moduleAttendance,
        TP2EvidentionEOR3LiveModule:
          attendanceSummary["eOR3 - Osobni razvoj 3.godina"]
            ?.onlineORLiveModuleAttendance,
      });
    }, 100);

    setTimeout(() => {
      setFormValues(formMethodsFive, {
        TTEvidentionIPRHours: iprHours,
        TTEvidentionGPRHours: gprHours,
        TTEvidentionIndividualSupervisions: individualSupervisionHours,
        TTEvidentionGroupSupervisions: groupSupervisionHours,
        TTWorkWithClientsHours: workWithClientsHours,
        TTSupervisorApproval:
          zavrsniRadovi.supervisorApproval1 !== null &&
          zavrsniRadovi.supervisorApproval2 !== null,
        TTZavrsniOR: zavrsniRadovi.zavrsniOR,
        TTCaseStudyOne: zavrsniRadovi.caseStudy1,
      });
    }, 100);

    const groupProgramLabels = groups
      .filter((group) => group.showProgramApplications && !group.isArchived)
      .map((group) => programIdToLabel[group.programId])
      .filter(Boolean);
    const appliedProgramLabels = programApplications
      .map((app) => applicationProgramIdToLabel[app.programId])
      .filter(Boolean);
    const combinedLabels = [
      ...new Set([...appliedProgramLabels, ...groupProgramLabels]),
    ];
    const desiredOrder = ["OR", "eOR", "TP1", "TP2", "TT"];
    const enrollmentOptions = combinedLabels.sort(
      (a, b) => desiredOrder.indexOf(a) - desiredOrder.indexOf(b)
    );
    setVisibleForm(enrollmentOptions);
    const newCommentModal = {};
    if (
      response.programApplications &&
      response.programApplications.length > 0
    ) {
      const newApplicationsCreated = { ...applicationsCreated };
      const acceptedMap = {};
      response.programApplications.forEach((programApplication) => {
        const parsedApplication = JSON.parse(programApplication.application);
        const programId = programApplication.programId;
        const program = applicationProgramOptions.find((option) =>
          option.value.includes(programId)
        );
        acceptedMap[program.label] = programApplication.isReferadaAccepted;

        if (!program) {
          console.error("Program not found for ID:", programId);
          return;
        }
        let formMethods;
        switch (program.label) {
          case "OR":
            formMethods = formMethodsOne;
            break;
          case "eOR":
            formMethods = formMethodsTwo;
            break;
          case "TP1":
            formMethods = formMethodsThree;
            break;
          case "TP2":
            formMethods = formMethodsFour;
            break;
          case "TT":
            formMethods = formMethodsFive;
            break;
          default:
            console.error("Unknown program label:", program.label);
            return;
        }
        Object.entries(parsedApplication).forEach(([key, value]) => {
          formMethods.setValue(key, value);
          newApplicationsCreated[program.label] = true;
        });
        newCommentModal[program.label] = {
          userId: programApplication.userId,
          applicationId: programApplication.id,
          mentorReview: programApplication.mentorReview,
          isReferadaAccepted: programApplication.isReferadaAccepted,
          reviewAuthor: programApplication.reviewAuthor,
          reviewAuthorId: programApplication.reviewAuthorId,
        };
      });
      setCommentModal(newCommentModal);
      setApplicationsCreated((prev) => {
        if (JSON.stringify(prev) === JSON.stringify(newApplicationsCreated)) {
          return prev;
        }
        return newApplicationsCreated;
      });
      setIsAccepted(acceptedMap);
    } else {
      console.log("No applications found or application field is missing.");
      Object.keys(formMethodsOne.getValues()).forEach((key) => {
        formMethodsOne.setValue(key, "");
      });
      Object.keys(formMethodsTwo.getValues()).forEach((key) => {
        formMethodsTwo.setValue(key, "");
      });
      Object.keys(formMethodsThree.getValues()).forEach((key) => {
        formMethodsThree.setValue(key, "");
      });
      Object.keys(formMethodsFour.getValues()).forEach((key) => {
        formMethodsFour.setValue(key, "");
      });
      setApplicationsCreated({
        OR: false,
        eOR: false,
        TP1: false,
        TP2: false,
        TT: false,
      });
    }
  } catch (error) {
    console.error("Error fetching form data:", error);
  }
};

export const filterApplicationsByProgram = (selectedProgram, applications) => {
  if (selectedProgram === null || selectedProgram === "0") {
    return applications?.applications || [];
  } else {
    const selectedProgramArray = selectedProgram?.split(",")?.map(Number);
    return (
      applications?.applications?.filter((application) =>
        selectedProgramArray.includes(application.programId)
      ) || []
    );
  }
};

export const filterApplicationsBySearch = (
  searchQuery,
  filteredApplications
) => {
  if (searchQuery.length === 0) return filteredApplications;

  return filteredApplications.filter((application) => {
    const fullName = `${application.User.firstName || ""} ${
      application.User.lastName || ""
    }`
      .trim()
      .toLowerCase();
    const normalizedQuery = searchQuery.toLowerCase().replace(/\s/g, "");
    return (
      fullName.includes(searchQuery.toLowerCase()) ||
      fullName.replace(/\s/g, "").includes(normalizedQuery)
    );
  });
};

export const extractUniqueGroups = (data) => {
  const uniqueGroupsMap = new Map();

  data.forEach((item) => {
    const group = item?.validGroup;
    if (group && group.id) {
      uniqueGroupsMap.set(group.id, group);
    }
  });

  return Array.from(uniqueGroupsMap.values());
};
